<template>
  <div class="page-content campus-list">
    <div class="header">
      <div class="btnBox ser" v-if="tabsShow">
        <a-button type="primary" @click="btnAllow"> 允许发布 </a-button>
        <a-button type="danger" @click="btnReject" style="margin-left:20px">
          拒绝发布
        </a-button>
      </div>
      <div class="searchBox ser">
        <a-auto-complete
          class="global-search"
          v-model="searchValue"
          style="width: 200px"
          placeholder="检索"
        />
      </div>
    </div>
    <div class="contentBox">
      <a-tabs :default-active-key="0" @change="tabsCallback">
        <a-tab-pane v-for="item in tabs" :key="item.key" :tab="item.name">
          <a-table
            :row-selection="{
              onChange: selectChenge,
              selectedRowKeys: selectedRowKeys
            }"
            tableLayout="fixed"
            :data-source="releaseList"
            :rowKey="releaseList => releaseList.id"
            :scroll="{ x: 1500 }"
            :loading="dataLoding"
            :pagination="{
              total: total,
              pageSize: pageSize,
              current: current,
              showTotal: total =>
                $t('public.page', { total: total, pageSize: pageSize }),
              onChange: currentChange
            }"
          >
            <a-table-column title="状态" :ellipsis="true" dataIndex="status">
              <template slot-scope="status, releaseList">
                <p>
                  {{
                    status == 0 ? '待审核' : status == 1 ? '已发布' : '拒绝发布'
                  }}
                </p>
              </template>
            </a-table-column>
            <a-table-column
              title="类型"
              :ellipsis="true"
              dataIndex="communityType"
            >
              <template slot-scope="communityType, releaseList">
                <p>{{ communityType == 1 ? '推荐' : '普通' }}</p>
              </template>
            </a-table-column>
            <a-table-column :width="600" title="内容" dataIndex="content">
            </a-table-column>

            <a-table-column
              :ellipsis="true"
              title="图片"
              dataIndex="matchIntro"
            >
              <template slot-scope="id, releaseList">
                <a @click="btnSeeDetail(releaseList.id)">查看详情</a>
              </template>
            </a-table-column>
            <a-table-column :ellipsis="true" title="发布人" dataIndex="name">
              <template slot-scope="id, releaseList">
                <p>
                  {{ releaseList.userId == 0 ? 'admin' : releaseList.name }}
                </p>
              </template>
            </a-table-column>
            <a-table-column title="发布时间" dataIndex="createTime">
            </a-table-column>
            <a-table-column
              :width="150"
              fixed="right"
              title="操作"
              dataIndex="operation"
            >
              <template slot-scope="id, releaseList">
                <a @click="() => btnEdit(releaseList.id)">编辑</a>
                <div class="border"></div>

                <a-popconfirm
                  title="确定删除?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="btnDelect(releaseList.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <a-modal
      :wrapClassName="noUpload ? 'modelHidden' : ''"
      :title="modelTitle"
      v-model="visibleAdd"
      :confirm-loading="confirmLoading"
      @ok="AddhandleOk"
    >
      <a-form
        :form="modelForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
        @submit="handleSubmit"
      >
        <a-form-item label="类型" v-if="!seeDetailFlag">
          <a-select
            placeholder="类型"
            v-decorator="[
              'communityType',
              {
                rules: [{ required: true, message: '请选择类型' }]
              }
            ]"
          >
            <a-select-option
              v-for="(item, index) in fundTypeData"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="内容" v-if="!seeDetailFlag">
          <a-input
            :max-length="150"
            type="textarea"
            v-decorator="[
              'content',
              {
                rules: [{ required: true, message: '请输入内容' }]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="图片">
          <a-upload
            multiple
            disabled
            accept="image/*"
            list-type="picture-card"
            :file-list="fileList"
            @preview="handlePreview"
            v-decorator="[
              'imageUrls',
              {
                rules: [{ required: true, message: '请添加图片' }]
              }
            ]"
          >
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="正在上传" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabs: [
        {
          name: '待审核',
          key: 0
        },
        {
          name: '已发布',
          key: 1
        },
        {
          name: '拒绝发布',
          key: 2
        }
      ],
      releaseList: [],
      total: 0,
      pageSize: 20,
      current: 1,
      searchValue: '',
      selectedRowKeys: [],
      content: '',
      status: 0,
      dataLoding: true,
      tabsShow: true,
      visibleAdd: false,
      fileList: [],
      previewVisible: false,
      previewImage: '',
      editId: '',
      seeDetailFlag: false,
      confirmLoading: false,
      fundTypeData: [
        {
          id: 0,
          name: '普通'
        },
        {
          id: 1,
          name: '推荐'
        }
      ],
      modelForm: this.$form.createForm(this, { name: 'modelForm' }),
      noUpload: false,
      modelTitle: '查看图片'
    }
  },
  methods: {
    //分页callback
    currentChange(val) {
      console.log(val)
    },
    tabsCallback(key) {
      if (key == 0) {
        this.tabsShow = true
      } else {
        this.tabsShow = false
      }
      this.status = key
      this.getPageData()
    },
    btnAllow() {
      if (this.selectedRowKeys.length == 0) {
        return false
      }
      let ids = this.stringData()
      let data = {
        ids,
        status: 1
      }
      this.$http(this.$api.OPERATION, data).then(r => {
        this.getPageData()
        this.selectedRowKeys = []
        this.$notification.open({
          type: 'success',
          message: '同意发布',
          description: '成功发布'
        })
      })
    },
    btnReject() {
      if (this.selectedRowKeys.length == 0) {
        return false
      }
      let ids = this.stringData()
      let data = {
        ids,
        status: 2
      }
      this.$http(this.$api.OPERATION, data).then(r => {
        this.selectedRowKeys = []
        this.$notification.open({
          type: 'success',
          message: '拒绝发布',
          description: '拒绝成功'
        })
        this.getPageData()
      })
    },
    stringData() {
      let ids = ''
      this.selectedRowKeys.forEach((val, index, array) => {
        console.log(array)
        if (index == array.length - 1) {
          ids += val.toString()
        } else {
          ids += val.toString() + ','
        }
      })
      return ids
    },
    selectChenge(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getPageData() {
      let data = {
        status: this.status,
        pageSize: this.pageSize,
        pageNum: this.current,
        communityType: '',
        content: this.content
      }
      this.$http(this.$api.GETALLCONTENT, data).then(r => {
        console.log(r)
        this.releaseList = r.data.records
        this.total = r.data.total
        this.dataLoding = false
      })
    },
    btnDelect(itemId) {
      let data = {
        id: itemId
      }
      this.$http(this.$api.DELECTDYNAMIC, data).then(r => {
        console.log(r)
        this.getPageData()
        this.$notification.open({
          type: 'success',
          message: '删除动态',
          description: '删除成功'
        })
        this.visibleAdd = false
      })
    },
    btnEdit(itemId) {
      this.visibleAdd = true
      this.editId = itemId
      this.selectFlag = 1
      this.fileList = []
      let data = {
        id: itemId
      }
      if (this.noUpload) {
        this.modelTitle = '查看图片'
      } else {
        this.modelTitle = '编辑'
      }
      this.$http(this.$api.EDITDYNAMIC, data).then(r => {
        this.visibleAdd = true
        let communityPicsDOS = r.data.communityPicsDOS
        communityPicsDOS.forEach(element => {
          this.fileList.push(JSON.parse(element.communityUrl))
        })
        console.log(this.fileList)
        this.$nextTick(() => {
          this.modelForm.setFieldsValue({
            imageUrls: this.fileList,
            communityType: r.data.communityDO.communityType,
            content: r.data.communityDO.content
          })
        })
      })
    },
    AddhandleOk() {
      this.handleSubmit()
    },
    handleSubmit() {
      this.confirmLoading = true
      this.modelForm.validateFields((err, data) => {
        if (!err) {
          data.imageUrls = this.fileList
          data.userId = 0
          console.log('Received values of form: ', data)
          data.id = this.editId
          this.$http(this.$api.UPDATEDYNAMIC, data).then(r => {
            this.confirmLoading = false
            this.getPageData()
            this.$notification.open({
              type: 'success',
              message: '编辑动态',
              description: '编辑成功'
            })
            this.visibleAdd = false
          })
        }
      })
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(e) {
      this.previewImage = e.url || e.preview
      this.previewVisible = true
    },
    btnSeeDetail(itemId) {
      console.log(itemId)
      this.noUpload = true
      this.seeDetailFlag = true
      this.btnEdit(itemId, true)
      this.confirmLoading = true
    }
  },
  watch: {
    searchValue(val) {
      this.content = val
      this.current = 1;
      this.getPageData()
    },
    visibleAdd(val) {
      console.log(val)
      if (!val) {
        this.confirmLoading = false
        this.seeDetailFlag = false
        this.noUpload = false
      }
    }
  },
  created() {
    this.getPageData()
  }
}
</script>
<style scoped lang="less">
.page-content {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .header {
    width: 100%;
    height: 80px;
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    .ser {
      float: left;
    }
    .ser:last-child {
      float: right;
    }
  }
  .contentBox {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  /deep/ .ant-table-tbody {
    /deep/ .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
  }
}
/deep/ .ant-modal-body {
  /deep/ .tableBox {
    width: 100%;
    height: 100%;
    .header {
      width: 100%;
      height: 60px;
      .ser {
        float: left;
        width: 50%;
      }
      .ser:last-child {
        .ant-btn {
          float: right;
        }
      }
    }
  }
  /deep/ .border {
    position: relative;
    top: -0.06em;
    display: inline-block;
    width: 1px;
    height: 0.9em;
    margin: 0 8px;
    vertical-align: middle;
    background-color: #e8e8e8;
  }
  /deep/ .ant-upload-list-item-card-actions {
    display: none;
  }
}
/deep/ .modelHidden {
  /deep/ .ant-modal-content {
    .ant-modal-footer {
      display: none;
    }
  }
}
</style>
